import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arraySlice',
})
export class ArraySlicePipe implements PipeTransform {

  public transform(value: any[], count: number): any[] {
    return value.slice(0, count);
  }

}
